module.exports = __webpack_public_path__ + "static/media/bf.5cfc3ec8.svg";